/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Cl_Approve_NoteInputs */

const en_st_cl_approve_note = /** @type {(inputs: St_Cl_Approve_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note (optional)`)
};

const id_st_cl_approve_note = /** @type {(inputs: St_Cl_Approve_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan (opsional)`)
};

/**
* | output |
* | --- |
* | "Note (optional)" |
*
* @param {St_Cl_Approve_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_cl_approve_note = /** @type {((inputs?: St_Cl_Approve_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Cl_Approve_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_cl_approve_note(inputs)
	return en_st_cl_approve_note(inputs)
});